import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router-dom'

import HeaderWithMenu from './header-with-menu'
import HeaderWithSignup from './header-with-signup'
import HeaderWithoutMenu from './header-without-menu'
import HeaderWithoutSignup from './header-without-signup'

function Header() {
  const [cookies] = useCookies()
  const stateCookieName = process.env.REACT_APP_STATE_COOKIE_NAME as string
  const isLoggedIn = cookies[stateCookieName] !== undefined
  const noMenuPageList = [
    '/signin',
    '/signup',
    '/2sv',
    '/error',
    '/policies',
    '/notices',
    '/language',
    '/dashboard/intro',
    '/dashboard/family-intro',
    '/adaptive-authentication'
  ]

  const location = useLocation()
  const currentPath = location.pathname.toLowerCase()
  const showMenu = !noMenuPageList.some((prefix) => currentPath.startsWith(prefix))
  const isDashboardIntro = currentPath.startsWith('/dashboard/intro')
  const isFamilyIntro = currentPath === '/dashboard/family-intro'

  return showMenu && isLoggedIn ? (
    <HeaderWithMenu />
  ) : isDashboardIntro ? (
    <HeaderWithSignup />
  ) : isFamilyIntro ? (
    <HeaderWithoutSignup />
  ) : (
    <HeaderWithoutMenu />
  )
}

export default Header
